import { render, staticRenderFns } from "./CopywritingNav2.vue?vue&type=template&id=28c5cffe&scoped=true&"
import script from "./CopywritingNav2.vue?vue&type=script&lang=js&"
export * from "./CopywritingNav2.vue?vue&type=script&lang=js&"
import style0 from "./CopywritingNav2.vue?vue&type=style&index=0&id=28c5cffe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c5cffe",
  null
  
)

export default component.exports